import { FilteredCreditApplication } from '@applyonline/shared'
import { useEffect } from 'react'
import { DataLayerEvent, ETrackingEvent } from '../types/tracking'

export const useTrackStepReachedEvent = (
  creditApp: FilteredCreditApplication | null,
  eventName: ETrackingEvent,
): void => {
  useEffect(() => {
    if (creditApp) {
      trackEvent(eventName, creditApp)
    }
  }, [creditApp, eventName])
}

export const trackEvent = (eventName: ETrackingEvent, creditApp: FilteredCreditApplication) => {
  const eventData = buildEventData(eventName, creditApp)

  trackGTagManagerEvent(eventData)
}

export const trackPlainEvent = (eventName: ETrackingEvent) => {
  trackGTagManagerEvent({
    event: eventName,
  })
}

const trackGTagManagerEvent = (eventData: DataLayerEvent) => {
  window.dataLayer.push(eventData)
}

const buildEventData = (eventName: ETrackingEvent, creditApp: FilteredCreditApplication): DataLayerEvent => {
  const eventID = `${eventName}-${creditApp.id ?? ''}`
  const requestedAmount = creditApp.requestedLoanAmount

  const baseEventData: DataLayerEvent = {
    event: eventName,
    form_id: eventID,
    credit_application_id: creditApp.id,
    reference_number: creditApp.referenceNumber,
    loan_info: {
      loan_duration: undefined,
      loan_interest_rate: undefined,
      loan_amount: requestedAmount,
    },
  }

  if (creditApp.normsDecision) {
    return {
      ...baseEventData,
      loan_info: {
        ...baseEventData.loan_info,
        loan_duration: creditApp.finalDecision.maxTermDuration,
        loan_interest_rate: creditApp.normsDecision.interestRate,
        loan_amount: Math.min(requestedAmount, creditApp.finalDecision.maxAmountFinanced),
      },
    }
  }

  if (creditApp.prequalificationDecision) {
    return {
      ...baseEventData,
      loan_info: {
        ...baseEventData.loan_info,
        loan_interest_rate: creditApp.prequalificationDecision.minInterestRate,
        loan_amount: Math.min(requestedAmount, creditApp.prequalificationDecision.maxLoanAmount),
      },
    }
  }

  return baseEventData
}
